export default __webpack_public_path__ + "static/media/rail-industry-2.6f9cd296.jpg";